import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
// import {
//     List, Edit, Create, Datagrid, Show, DateField, ReferenceManyField,
//     ReferenceField, TextField, ArrayField, ShowButton, SingleFieldList,
//     DisabledInput, ReferenceInput, AutocompleteInput,
//     SelectInput, SimpleForm, DeleteButton, NumberInput, DateInput, Filter, SimpleShowLayout, ImageInput, ImageField, EditButton, TopToolbar, required, SimpleFormIterator, ArrayInput, TextInput,
// } from 'react-admin';

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from './common/common';
import { useLocation } from 'react-router-dom';

const SapSdoDispute  = (props) => {

    const [loadingShow , setLoadingShow] = React.useState(true);
    const [orderSdoDispute, setOrderSdoDispute] = React.useState({});

    const location = useLocation();
    const pathSplit = location.pathname.split('/');
    const sapSdoId = pathSplit[2]



    const ShowImage = (url) => {
        window.open(url, '_blank');
    }

    React.useEffect(() =>{
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';

            fetch(`${apiUrl}/sap_sdo_for_orders/${sapSdoId}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                setLoadingShow(false);
                setOrderSdoDispute(jsonD.data);
            }).catch(err => {
                setLoadingShow(true);
            });

    },[])

        return (
            <div className="del-dis-page">
                {
                !loadingShow &&
                <div title="Order Materials">
                    {
                        orderSdoDispute && orderSdoDispute.order_number &&
                        <div className="data-box">
                            <h2 className="data-heading">Order Number: {orderSdoDispute.order_number}</h2>
                        {orderSdoDispute.logon_order_no ? <h3 className="data-heading">Delivery number: {orderSdoDispute.logon_order_no} </h3> : <div className="data-heading">No delivery number</div>}
                        {orderSdoDispute.receive_order_note ? <h3 className="data-heading">Dispute Note: {orderSdoDispute.receive_order_note} </h3> : <div className="data-heading">No dispute</div>}
                            <div className="image-wrapper">
                                {
                                orderSdoDispute?.sap_sdo_dispute?.map(dispute => (
                                    <div className="lr-image-dispute" key={dispute.id}>
                                        <img alt="" onClick={() => { ShowImage(dispute.receive_order_image); }} className="maxH200" src={dispute.receive_order_image} />
                                    </div>
                                ))
                                }
                            </div>
                        </div> 
                    }
                </div>
                }
            </div>
        );

}

export default SapSdoDispute